<template>
    <b-container fluid class="p-0">
        <b-row v-for="(value, key) in getRenderSchedule" :key="key" class="border-bottom py-2">
            <b-col sm="12" md="12" lg="3" class="d-flex flex-row justify-content-between align-content-center align-items-center">
                <span class="">{{convertValidDayName(key)}}</span>
                <b-form-checkbox class="align-middle" v-model="value.closed">{{type}}</b-form-checkbox>
                <div v-if="!value.closed" class="d-block d-lg-none">
                    <b-btn size="sm" variant="danger" v-if="value.items.length > 1" @click="removeExtraHour(value)">
                        Remove Shift
                    </b-btn>
                    <b-btn size="sm" variant="success" v-else @click="addExtraHour(value, key)" >
                        Add Shift
                    </b-btn>
                </div>
            </b-col>
            <b-col sm="12" md="12" lg="7" v-if="!value.closed">
                <b-row class=" my-2" v-for="item in value.items">
                    <b-col>
                        <b-input-group size="sm" prepend="From">
                            <b-form-select class="small" v-model="item.StartTime" :options="fromHours"/>
                        </b-input-group>
                    </b-col>
                    <b-col>
                        <b-input-group size="sm" prepend="To">
                            <b-form-select v-model="item.EndTime" :options="toHours"/>
                        </b-input-group>
                    </b-col>
                </b-row>
            </b-col>
            <b-col sm="12" lg="2" class="d-none d-lg-flex flex-row justify-content-between align-content-center align-items-center">
                <div v-if="!value.closed" class="text-center m-auto flex-row justify-content-between align-content-center align-items-center">
                    <b-btn size="sm" variant="link" class="text-decoration-none" v-if="value.items.length > 1" @click="removeExtraHour(value)">
                        Remove Shift
                    </b-btn>
                    <b-btn size="sm" variant="link" class="text-decoration-none" v-else @click="addExtraHour(value, key)" >
                        Add Shift
                    </b-btn>
                </div>
            </b-col>
        </b-row>
        <b-row v-if="showError">
            <b-col sm="12" class="p-1 my-2">
                <b-alert v-if="showError" dismissible @dismissed="showError=false" variant="danger" show>Please set hours of operation for all week days to proceed.
                </b-alert>
            </b-col>
        </b-row>

        <b-row class="flex-grow-1 mt-3">
            <b-col cols="6">
                <b-btn variant="warning" block class="text-nowrap" :disabled="progressing" @click="setTime">
                    <span v-if="loadBtn">
                        <font-awesome-icon spin icon="circle-notch" class="align-middle"/>
                    </span>
                    <span v-else>
                        Save Changes
                    </span>
                </b-btn>
            </b-col>

            <b-col cols="6">
                <b-btn variant="danger" block class="text-nowrap cancel-btn-cmodal" @click="cancel">
                    Cancel
                </b-btn>
            </b-col>
        </b-row>
<!--        -->
<!--        <b-row>-->
<!--            <b-col sm="12" class="p-1 mt-4">-->
<!--                <b-btn class="processBtnModal" :disabled="loadBtn" @click="setTime">-->
<!--                    <span v-if="loadBtn">-->
<!--                        <font-awesome-icon spin icon="circle-notch" class="align-middle"/>-->
<!--                    </span>-->
<!--                    <span v-else>-->
<!--                        Save Changes-->
<!--                    </span>-->
<!--                </b-btn>-->
<!--                <b-btn class="cancelBtnModal ml-2" @click="cancel">Cancel</b-btn>-->
<!--            </b-col>-->
<!--        </b-row>-->
    </b-container>
</template>

<script>
    export default {
        name: "operationScheduleModal",
        props: {
            schedules: {
                required: true
            },
            renderSchedules: {
                required: true
            },
            loadBtn: {
                required: true
            },
            type: {
                type: String
            }
        },
        computed: {
            getRenderSchedule () {
                return this.renderSchedules
            }
        },
        data () {
            return {
                fromHours: [
                    "00:00 AM",
                    "00:30 AM",
                    "01:00 AM",
                    "01:30 AM",
                    "02:00 AM",
                    "02:30 AM",
                    "03:00 AM",
                    "03:30 AM",
                    "04:00 AM",
                    "04:30 AM",
                    "05:00 AM",
                    "05:30 AM",
                    "06:00 AM",
                    "06:30 AM",
                    "07:00 AM",
                    "07:30 AM",
                    "08:00 AM",
                    "08:30 AM",
                    "09:00 AM",
                    "09:30 AM",
                    "10:00 AM",
                    "10:30 AM",
                    "11:00 AM",
                    "11:30 AM",
                    "12:00 PM",
                    "12:30 PM",
                    "01:00 PM",
                    "01:30 PM",
                    "02:00 PM",
                    "02:30 PM",
                    "03:00 PM",
                    "03:30 PM",
                    "04:00 PM",
                    "04:30 PM",
                    "05:00 PM",
                    "05:30 PM",
                    "06:00 PM",
                    "06:30 PM",
                    "07:00 PM",
                    "07:30 PM",
                    "08:00 PM",
                    "08:30 PM",
                    "09:00 PM",
                    "09:30 PM",
                    "10:00 PM",
                    "10:30 PM",
                    "11:00 PM",
                    "11:30 PM",
                    
                ],
                toHours: [
                    "00:30 AM",
                    "01:00 AM",
                    "01:30 AM",
                    "02:00 AM",
                    "02:30 AM",
                    "03:00 AM",
                    "03:30 AM",
                    "04:00 AM",
                    "04:30 AM",
                    "05:00 AM",
                    "05:30 AM",
                    "06:00 AM",
                    "06:30 AM",
                    "07:00 AM",
                    "07:30 AM",
                    "08:00 AM",
                    "08:30 AM",
                    "09:00 AM",
                    "09:30 AM",
                    "10:00 AM",
                    "10:30 AM",
                    "11:00 AM",
                    "11:30 AM",
                    "12:00 PM",
                    "12:30 PM",
                    "01:00 PM",
                    "01:30 PM",
                    "02:00 PM",
                    "02:30 PM",
                    "03:00 PM",
                    "03:30 PM",
                    "04:00 PM",
                    "04:30 PM",
                    "05:00 PM",
                    "05:30 PM",
                    "06:00 PM",
                    "06:30 PM",
                    "07:00 PM",
                    "07:30 PM",
                    "08:00 PM",
                    "08:30 PM",
                    "09:00 PM",
                    "09:30 PM",
                    "10:00 PM",
                    "10:30 PM",
                    "11:00 PM",
                    "11:30 PM",
                    "11:59 PM",
                    
                ],
                showError: false
            }
        },
        methods: {
            convertValidDayName (WeekdayId) {
                switch (WeekdayId) {
                    case '0' : return 'Sun'
                    break;
                    case '1' : return 'Mon'
                    break;
                    case '2' : return 'Tue'
                    break;
                    case '3' : return 'Wed'
                    break;
                    case '4' : return 'Thu'
                    break;
                    case '5' : return 'Fri'
                    break;
                    case '6' : return 'Sat'
                    break;
                    default: return ''
                }
            },
            addExtraHour (value, key) {
                //add extra hour for each day
                value.items.push({
                    WeekdayId: Number(key),
                    StartTime: '',
                    EndTime: '',
                    closed: value.closed
                })
            },
            removeExtraHour (value) {
                //remove extra hour for each day
                value.items.splice(1, 1)
            },
            setTime () {
                let data = {...this.getRenderSchedule}
                let arr = []
                for (let key in data) {
                    if (data[key].closed) {
                        data[key].items.forEach(i => {
                            i.StartTime = 'CLOSED'
                            i.EndTime = ''
                        })
                    }
                    //Delete items whose startTime is closed

                    if (data[key].items.length > 1) {
                        if (data[key].items.filter(i => i.StartTime === 'CLOSED').length > 1) {
                            data[key].items.splice(1, 1)
                        }
                    }
                }
                for (let key in data) {
                    for (let i in data[key].items){
                        data[key].items[i].closed = data[key].closed
                        arr.push(data[key].items[i])
                    }
                }
                let findEmptyHourWithNotClose = arr.find(i => i.closed === false && (i.StartTime === 'CLOSED' || i.EndTime === ''))
                let findEmptyHourWithClose = arr.find(i => i.closed === false && (!i.StartTime.length || !i.EndTime.length))
                if (findEmptyHourWithNotClose) {
                    this.showError = true
                } else if (findEmptyHourWithClose) {
                    this.showError = true
                } else {
                    this.showError = false
                    arr.forEach(item => {
                        if (item.closed) {
                            item.StartTime = 'CLOSED'
                            item.EndTime = ''
                        }
                    })
                    this.$emit('setTime', arr)
                }
            },
            cancel () {
                this.$emit('cancelSchedule', false)
            }
        }
    }
</script>

<style scoped>

</style>
